import { Component, inject, Input } from '@angular/core';
import { Order } from '../../lib/interfaces/Order';
import { CommonService } from '../../services/common/common.service';
import { PaymentType } from '../../lib/enums/PaymentType';
import { OrderType } from '../../lib/enums/OrderType';
import { OverlayService } from '../../services/overlay/overlay.service';

@Component({
    standalone: true,
    selector: 'app-customer-order-details',
    templateUrl: './customer-order-details.component.html',
    styleUrl: './customer-order-details.component.scss',
    imports: [],
})
export class CustomerOrderDetailsComponent {
    @Input({ required: true }) customerOrder!: Order;
    @Input() detailed: boolean = false;

    protected paymentType?: PaymentType;

    protected commonService: CommonService = inject(CommonService);
    private overlayService: OverlayService = inject(OverlayService);

    protected getOrderTypeText(orderType: OrderType): string {
        switch (orderType) {
            case OrderType.DELIVERY:
                return 'Lieferung';
            case OrderType.TAKEAWAY:
                return 'Zum Mitnehmen';
            case OrderType.ON_SITE:
                return 'Vor Ort';
            default:
                return '';
        }
    }

    protected navigateToOrderOverview(): void {
        this.commonService.navigateToRoute(
            `/confirm/${this.customerOrder.service?.uid}/success/${this.customerOrder.identificationTag}`,
        );
        this.overlayService.close();
    }
}
